import hbscan from "../../api/hbscan";
import IContact from "../../models/contact";
import Auth from "../auth/AuthService";


class ContactService {
  GetContactsByCompany = async () => {
    const URL = `/api/hbscan/contact/GetContactsByCompany`;

    return (
      await hbscan.get<IContact[]>(URL, {
        headers: { Authorization: Auth.guid },
      })
    ).data || [];
  };

  CreatePunchContact = async (contact: IContact) => {
    const URL = `/api/hbscan/contact/CreatePunchContact`;

    return (
      await hbscan.post<number>(URL, contact, {
        headers: { Authorization: Auth.guid },
      })
    ).data || null;
  }

  UpdatePunchContact = async (contact: IContact) => {
    const URL = `/api/hbscan/contact/UpdatePunchContact`;

    return (
      await hbscan.put<number>(URL, contact, {
        headers: { Authorization: Auth.guid },
      })
    ).data || null;
  }
}

const contactService = new ContactService();

export default contactService;
